import React, { useEffect, useState, useRef } from "react"
import { IconContext } from "react-icons/lib"
import { FaRegUserCircle } from "react-icons/fa"
import { useCustomer } from "../../../contexts/CustomerContext"
import { useUser } from "../../../contexts/UserContext"
import { CgRadioCheck } from "react-icons/cg"
import { RxRadiobutton } from "react-icons/rx"
import { BsCaretDown } from "react-icons/bs"
import { useUserPreferences } from "../../../contexts/UserPreferencesContext"

const UserDropdown = () => {
	const [showCustomerDropdown, setShowCustomerDropdown] = useState(false)

	const divRef = useRef<HTMLDivElement>(null)

	const { customer, setSelectedCustomerId, userCustomers } = useCustomer()
	const { collapsed } = useUserPreferences()
	const { user } = useUser()

	const handleClickInside = () => {
		if (userCustomers.length) setShowCustomerDropdown(true)
	}

	function handleClickOutside(e: MouseEvent) {
		if (!divRef.current.contains(e.target as HTMLInputElement)) {
			setShowCustomerDropdown(false)
		}
	}

	useEffect(() => {
		document.addEventListener("click", handleClickOutside)
		return () => document.removeEventListener("click", handleClickOutside)
	}, [])

	const onSelectedCustomerChange = (id: string) => {
		setSelectedCustomerId(id)
	}

	return (
		<div className="sidebar-user-list" ref={divRef} onClick={handleClickInside}>
			<IconContext.Provider value={{ className: "sidebar-user-icon" }}>
				<FaRegUserCircle />
			</IconContext.Provider>
			{!collapsed && (
				<div className="sidebar-license-container">
					<div className="sidebar-license-name" title={user?.Username || ''}>
						{user?.Username
							? user.Username.length > 12
								? user.Username.slice(0, 12) + '...'
								: user.Username
							: 'N/A'}
					</div>
					<div className="sidebar-license-dropdown">
						{customer?.Name || 'No customer'}
						{userCustomers?.length > 0 && (
							<IconContext.Provider value={{ className: "sidebar-user-icon" }}>
								<BsCaretDown />
							</IconContext.Provider>
						)}
					</div>
				</div>
			)}
			{showCustomerDropdown && userCustomers?.length > 0 && (
				<ul className="sidebar-settings-user-nested">
					{userCustomers.map(el => (
						<li
							className="sidebar-settings-radio"
							key={el.Id}
							onClick={() => onSelectedCustomerChange(el.Id)}
						>
							{el.CustomerGroupName && `${el.CustomerGroupName} - `}{el.Name}
						</li>
					))}
				</ul>
			)}
		</div>
	)
}

export default UserDropdown